// require('suggestions-jquery');
require('../module/file.change.js');
// require('../module/url_get.js');
// require('../module/textarea_autosize.js');

window.project = {

    init: function () {
        $('[users-add]').on('click', project.user.add);
        $(document).on('click', '[users-del]', project.user.del);
        $('[project-form]').on('submit', project.send);
        $('[file-delete]').on('click', project.file.delete);
        project.educational.selectize();
        project.suggestions();
    },

    file: {
        delete: function () {
            var file = $(this).attr('file-delete'),
                id = $(this).attr('project-id'),
                html = $(this).parents('.multi-files:eq(0)');

            ajax({
                url: '/project' + (id ? '/' + id : ''),
                data: {
                    file_delete: file
                },
                type: 'PUT',
                dataType: 'json'
            }, function (json) {
                if (json.success) {
                    html.remove();
                } else if (json.error) {
                    alert(json.error);
                } else {
                    debug.send(json);
                }
            });
        }
    },

    user: {
        add: function () {
            var input = $('[user-field]:eq(0)').clone().removeClass('d-none');
            $('[user-field]:eq(-1)').after(input);
        },
        del: function () {
            $(this).parents('[user-field]').remove();
        }
    },

    educational: {
        search: function (str, callbak) {
            $.get('/api/highereducational', {
                _token: csrf_token,
                name: str,
                limit: 50
            }, function (json) {
                callbak(json.data);
            }, 'json').fail(callbak);
        },
        selectize: function () {
            $('[name="higher_educational_id"]').selectize({
                loadThrottle: 800,
                maxItems: 1,
                valueField: 'id',
                labelField: 'name',
                searchField: ['name', 'address'],
                create: true,
                load: project.educational.search,
                onFocus: function () {
                    $('[name="higher_educational_id"]')[0].selectize.clear();
                },
                render: {
                    option_create: function(data, escape) {
                        return '<div class="create">Добавить ВУЗ: <strong>' + escape(data.input) + '</strong></div>';
                    },
                    option: function (item, escape) {
                        return '<div class="option">'
                            + escape(item.name)
                            + '<strong>'
                            + (
                                item.address
                                    ? ', ' + escape(item.address)
                                    : ''
                            )
                            + '</strong>'
                        '</div>';
                    },
                    item: function (item, escape) {
                        return '<div>' + escape(item.name) + '</div>';
                    }
                }
            });
        }
    },

    send: function (e) {
        e.preventDefault();

        var form = $(this);

        ajax({
            url: '/project',
            data: new FormData(form[0]),
            contentType: false,
            processData: false,
            type: 'post',
            dataType: 'json'
        }, function (json) {
          if (json.success) {
            console.log('json.success');
            $('#successtakeModal').modal('show');
            form.trigger('reset');
            if (!json.update)
              forgetForm();
          } else if (json.error) {
            console.log('json.error');
            alert(json.error);
          } else {
            console.log('json.responseText');
            debug.send(json.responseText);
          }
        }, form);

        return false;
    },

    suggestions: function () {
        if ($('[name="region"]').length) {
            $('[name="region"]').suggestions({
                token: "36b2bcc167c5e037f27cd63f28788e6639708a43",
                type: "ADDRESS",
                hint: false,
                bounds: "region",
                formatSelected: function (suggestion) {
                    return suggestion.data.region_with_type;
                },
                formatResult: function (value, currentValue, suggestion, options) {
                    var newValue = suggestion.data.region_with_type;
                    suggestion.value = newValue;
                    return $.Suggestions.prototype.formatResult.call(this, newValue, currentValue, suggestion, options);
                }
            });
        }
    },
}

project.init();

function forgetForm() {
  window.localStorage.removeItem('participation_form');
  ajax({
    method: 'POST',
    url: '/account/participation.save',
    data: []
  });
}
